import type { schemas } from '@gonfalon/openapi/types';

export interface Operator {
  op: schemas['Operator'];
  textValue: string;
  negate: boolean;
}

export const operators: Operator[] = [
  { op: 'in', textValue: 'is one of', negate: false },
  { op: 'in', textValue: 'is not one of', negate: true },
  { op: 'endsWith', textValue: 'ends with', negate: false },
  { op: 'endsWith', textValue: 'does not end with', negate: true },
  { op: 'startsWith', textValue: 'starts with', negate: false },
  { op: 'startsWith', textValue: 'does not start with', negate: true },
  { op: 'contains', textValue: 'contains', negate: false },
  { op: 'contains', textValue: 'does not contain', negate: true },
  { op: 'lessThan', textValue: '<', negate: false },
  { op: 'lessThanOrEqual', textValue: '<=', negate: false },
  { op: 'greaterThan', textValue: '>', negate: false },
  { op: 'greaterThanOrEqual', textValue: '>=', negate: false },
  { op: 'before', textValue: 'before', negate: false },
  { op: 'after', textValue: 'after', negate: false },
  { op: 'semVerEqual', textValue: 'SemVer is one of', negate: false },
  { op: 'semVerEqual', textValue: 'SemVer is not one of', negate: true },
  { op: 'semVerLessThan', textValue: 'SemVer <', negate: false },
  { op: 'semVerGreaterThan', textValue: 'SemVer >', negate: false },
];
